import styled from "@emotion/styled";
import React from "react";
import { PageContainer, PageRoot } from "Styles/PageStyles";

/** Shared loader footprint for student list and related student views that use the same table chrome. */
export const studentsTableLoaderContainerStyles: React.CSSProperties = {
    height: "calc(100vh - 60px)",
    width: "calc(100vw - 80px)",
};
export const StudentTableWrapper = styled.div`
    width: calc(100vw - 80px);
    .mainTable {
        & > div {
            &:first-child {
                background: #f3f3f3;
            }
            & > div {
                &:nth-of-type(even) {
                    background: #f9f9f9;
                }
                & > div {
                    width: 100%;
                    box-sizing: border-box;
                    &:last-child {
                        border-right: none;
                    }
                }
            }
        }
        .justifyCenter {
            > div {
                justify-content: center;
            }
        }
        #lastAction {
            justify-content: flex-end;
        }
    }
`;

export const EmailToggle = styled.div`
    position: relative;
    cursor: pointer;
    & > div {
        position: absolute;
        right: 0;
        top: 100%;
        height: 0;
        max-width: 350px;
        width: 350px;
        overflow: hidden;
        z-index: 11;
        & > span {
            padding: 12px 15px;
            border-radius: 5px;
            background: #fff;
            box-shadow: 0px 3px 3px #00000029;
            border: 1px solid #f3f3f3;
            display: grid;
            grid-template-columns: 14px 14px auto;
            gap: 10px;
            align-items: center;
            img {
            }
        }
    }
    &:hover {
        & > div {
            height: auto;
        }
    }
`;

export const ViewStudentDetailsButton = styled.button`
    height: 30px;
    border-radius: 5px;
    letter-spacing: 0px;
    color: #000000;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 17px;
    font-family: OpenSans-CondBold;
    background-color: #fcd21d;
    border: none;
    width: 100%;
    display: block;
    box-sizing: border-box;
    padding: 6px 30px;
    cursor: pointer;
    @media only screen and (max-width: 1800px) {
        padding: 6px 20px;
    }
    @media only screen and (max-width: 1600px) {
        padding: 6px 10px;
    }
`;

export const OuterSelect = styled.div`
    width: 150px;
    @media only screen and (max-width: 767px) {
        width: calc(100% - 135px);
        margin-right: 0px !important;
    }
`;

export const AddStudent = styled.div`
    .add-student {
        min-width: 310px;
        height: 40px;
        @media only screen and (max-width: 1100px) {
            min-width: auto;
        }
        @media only screen and (max-width: 767px) {
            min-width: 100%;
        }
    }
`;

export const StudentsTablePageRoot: React.FC<{ children: React.ReactNode; style?: React.CSSProperties }> = ({ children, style }) => (
    <PageRoot style={{ paddingBottom: "10rem", background: "#fff", flex: 1, minHeight: 0, ...style }}>{children}</PageRoot>
);

export const StudentsTablePageContainer: React.FC<{ children: React.ReactNode }> = ({ children }) => <PageContainer padding="15px 0px 0px 0px">{children}</PageContainer>;
